import React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { RootState } from "../../app/store";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { updateSelectedPrompt } from "../../app/promptsSlice";

function IncludeFormControl() {
  const dispatch = useAppDispatch();
  const toInclude = useAppSelector(
    (state: RootState) => state.prompts.selectedPrompt.toInclude
  );

  const handleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const newToInclude = event.target.value;
    dispatch(updateSelectedPrompt({ toInclude: newToInclude }));
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          multiline
          id="include-textfield"
          rows={2}
          label="Include in output"
          slotProps={{ inputLabel: { shrink: true } }}
          placeholder='e.g. "I remember", "Following your email"'
          helperText="Add values separated by a comma"
          variant="outlined"
          value={toInclude}
          onChange={handleChange}
        />
      </FormControl>
    </Box>
  );
}

export default IncludeFormControl;
